<template>
  <div class="col-xl-4 xl-100">
    <px-card title="Order status">
      <div class="card-body">
        <apexchart
          type="donut"
          height="330"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </px-card>
  </div>
</template>

<script>
const STATUS_COLORS = {
  Processing: "#4680ff",
  Shipped: "#ffb64d",
  Delivered: "#51bb25",
  Cancelled: "#f73164"
};

export default {
  name: "order-status-chart",
  props: {
    stats: { type: Object, required: true }
  },
  computed: {
    entries() {
      const counts = this.stats.statusCounts || {};
      const labels = ["Processing", "Shipped", "Delivered", "Cancelled"].filter(
        (key) => key in counts
      );
      Object.keys(counts).forEach((key) => {
        if (labels.indexOf(key) === -1) {
          labels.push(key);
        }
      });
      return { labels, values: labels.map((key) => counts[key] || 0) };
    },
    series() {
      return this.entries.values;
    },
    chartOptions() {
      const total = this.entries.values.reduce((sum, value) => sum + value, 0);
      return {
        chart: { type: "donut", fontFamily: "inherit" },
        labels: this.entries.labels,
        colors: this.entries.labels.map(
          (label) => STATUS_COLORS[label] || "#a7a7a7"
        ),
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        stroke: { width: 2, colors: ["#fff"] },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Orders",
                  formatter: () => String(total)
                }
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style></style>
